import React, { useContext } from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { UserContext } from "./contexts/UserContext";
import AuthRoute from "./components/AuthRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";

const App = () => {
  const auth = useContext(UserContext);
  return (
    <Router>
      <Switch>
        <Redirect exact from="/" to="/login" />
        <ProtectedRoute
          path="/dashboard"
          component={Dashboard}
          loggedIn={auth.loggedIn}
        />
        <AuthRoute
          exact
          path="/login"
          component={Login}
          loggedIn={auth.loggedIn}
        />
        <AuthRoute
          exact
          path="/register"
          component={Register}
          loggedIn={auth.loggedIn}
        />
        <Redirect from="*" to="/" />
      </Switch>
    </Router>
  );
};

export default App;
